import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, ExternalLink } from 'lucide-react';
import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/Card/Card';
import { Badge } from '@/components/ui/Badge/Badge';
import type { ClientDTO } from '@/services/ClientsService';

interface ClientInfoCardProps {
  client: ClientDTO;
}

export function ClientInfoCard({ client }: ClientInfoCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle as="h3">Client Information</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 bg-primary-100 rounded-lg flex items-center justify-center flex-shrink-0">
              <Building2 className="w-5 h-5 text-primary-600" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="font-semibold truncate">{client.name}</h4>
            </div>
          </div>

          {client.contact_name && (
            <div>
              <p className="text-xs text-muted-foreground mb-1">Contact Person</p>
              <p className="text-sm">{client.contact_name}</p>
              {client.contact_email && (
                <p className="text-sm text-muted-foreground">{client.contact_email}</p>
              )}
            </div>
          )}

          <Link
            to={`/organization/clients/${client.id}`}
            className="inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 hover:underline"
          >
            View Client Details
            <ExternalLink className="w-3 h-3" />
          </Link>
        </div>
      </CardContent>
    </Card>
  );
}

